import { EnvCodeEnum } from "@monorepo/types";

import {
  DEV_DOMAIN,
  PROD_SERVICE_DOMAIN,
  SANDBOX_SERVICE_DOMAIN,
  STG_SERVICE_DOMAIN,
  TEST_SERVICE_DOMAIN,
  WEB_DOMAINS,
} from "./domains";
import { HOSTNAME } from "./hostname";
import { LANGUAGE } from "./language";

const getDomain = () => {
  const urlBeginning = "https://";

  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].test) {
    return urlBeginning + WEB_DOMAINS[LANGUAGE].test;
  }

  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].sandbox) {
    return urlBeginning + WEB_DOMAINS[LANGUAGE].sandbox;
  }

  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].stg) {
    return urlBeginning + WEB_DOMAINS[LANGUAGE].stg;
  }

  if (HOSTNAME === TEST_SERVICE_DOMAIN) {
    return urlBeginning + TEST_SERVICE_DOMAIN;
  }

  if (HOSTNAME === SANDBOX_SERVICE_DOMAIN) {
    return urlBeginning + SANDBOX_SERVICE_DOMAIN;
  }

  if (HOSTNAME === STG_SERVICE_DOMAIN) {
    return urlBeginning + STG_SERVICE_DOMAIN;
  }

  if (HOSTNAME === PROD_SERVICE_DOMAIN) {
    return urlBeginning + PROD_SERVICE_DOMAIN;
  }

  if (HOSTNAME?.includes("localhost")) {
    return "http://" + DEV_DOMAIN;
  }
  //making default return of prod
  return urlBeginning + WEB_DOMAINS[LANGUAGE].prod;
};

export const DOMAIN = getDomain();

const getEnv = () => {
  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].stg || HOSTNAME === STG_SERVICE_DOMAIN) {
    return EnvCodeEnum.STAGING;
  }

  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].test || HOSTNAME === TEST_SERVICE_DOMAIN) {
    return EnvCodeEnum.TEST;
  }

  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].sandbox || HOSTNAME === SANDBOX_SERVICE_DOMAIN) {
    return EnvCodeEnum.SANDBOX;
  }

  if (HOSTNAME?.includes("localhost")) {
    return EnvCodeEnum.LOCAL;
  }
  //making default return of prod
  return EnvCodeEnum.PROD;
};

export const ENVIRONMENT = getEnv();

const getEnvString = () => {
  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].stg || HOSTNAME === STG_SERVICE_DOMAIN) {
    return String(EnvCodeEnum.STAGING_TEXT);
  }

  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].test || HOSTNAME === TEST_SERVICE_DOMAIN) {
    return String(EnvCodeEnum.TEST_TEXT);
  }

  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].sandbox || HOSTNAME === SANDBOX_SERVICE_DOMAIN) {
    return String(EnvCodeEnum.SANDBOX_TEXT);
  }

  if (HOSTNAME?.includes("localhost")) {
    return String(EnvCodeEnum.LOCAL_TEXT);
  }
  //making default return of prod
  return String(EnvCodeEnum.PROD_TEXT);
};

export const ENVIRONMENT_STRING = getEnvString();

const getThirdPartyData = () => {
  const perlasgoThirdPartyAttachedHostname = document
    ?.getElementById("perlasgo-third-party-attached")
    ?.getAttribute("data-hostname");
  if (!!perlasgoThirdPartyAttachedHostname && !!perlasgoThirdPartyAttachedHostname?.length) {
    return { IS_THIRD_PARTY: true, THIRD_PARTY_HOSTNAME: perlasgoThirdPartyAttachedHostname };
  }
  return { IS_THIRD_PARTY: false, THIRD_PARTY_HOSTNAME: undefined };
};

export const { IS_THIRD_PARTY, THIRD_PARTY_HOSTNAME } = getThirdPartyData();
